import { types, actions } from './requests'
export const GETURGENTCLIENTORDERLIST_TYPES = {
    ...types('GETURGENTCLIENTORDERLIST'),
}
export const GETURGENTCLIENTORDERLIST_ACTIONS = {
    ...actions('GETURGENTCLIENTORDERLIST'),
}
